module.exports = __webpack_public_path__ + "9103e052d7219987743fcacb9452c574.svg";